import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import apis from "../../services";

const ApproveWithDrawlModal = ({
  status = true,
  close,
  amount,
  withDrawId,
  fetchAllWithDrawlUser,
  fullName,
  paidAmount,
}) => {
  const [transactionId, setTransactionId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submitHandler = async (event) => {
    event.preventDefault();

    if (!transactionId.trim()) {
      toast.error("Transaction Id is required");
      return;
    }

    if (submitting) return;

    setSubmitting(true);
    try {
      const data = { withDrawId, transactionId: transactionId.trim() };
      const res = await apis.approvedWithdrawl(data);
      if (res?.data?.status) {
        toast.success(res.data?.message);
        await fetchAllWithDrawlUser();
        close();
      } else {
        toast.error(res?.data?.message || "Unable to approve withdrawl request");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to approve withdrawl request"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog maxWidth={"md"} open={status} onClose={close}>
      <DialogTitle>Approve Withdrawl Request</DialogTitle>
      <Form onSubmit={submitHandler}>
        <DialogContent dividers sx={{ width: 500 }}>
          <Grid item container>
            <Grid item xs={12}>
              <Form.Group className="mb-3" controlId="shares">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the Full Name"
                  name=""
                  value={fullName}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="reserveShares">
                <Form.Label>Retention</Form.Label>
                <Form.Control type="text" placeholder="" value="10%" disabled />
              </Form.Group>
              <Form.Group className="mb-3" controlId="reserveShares">
                <Form.Label>Withdrawl Amount</Form.Label>
                <Form.Control type="number" placeholder="" value={amount} disabled />
              </Form.Group>
              <Form.Group className="mb-3" controlId="shares">
                <Form.Label>Payable Amount</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the Payable amount"
                  value={paidAmount}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="shares">
                <Form.Label>Transaction Id</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the transaction id"
                  name="transactionId"
                  onChange={(e) => setTransactionId(e.target.value)}
                />
              </Form.Group>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid item container justifyContent="flex-end" gap={2}>
            <Button
              className="lp-btn"
              onClick={close}
              disabled={submitting}
              style={{ backgroundColor: "#212529", borderColor: "#212529" }}
            >
              Cancel
            </Button>
            <Button className="lp-btn" type="submit" disabled={submitting}>
              {submitting ? "Processing..." : "Confirm"}
            </Button>
          </Grid>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default ApproveWithDrawlModal;
